/** Shared React Query retry policy — conservative for congested networks. */

const MAX_QUERY_RETRIES = 1;
const RETRY_BASE_MS = 3000;
const RETRY_JITTER_MS = 2000;

function getHttpStatus(error) {
  if (typeof error?.status === 'number') return error.status;
  if (typeof error?.statusCode === 'number') return error.statusCode;
  return null;
}

function isClientError(error) {
  const status = getHttpStatus(error);
  if (status != null && status >= 400 && status < 500) return true;

  const code = String(error?.code ?? '').toUpperCase();
  if (code.startsWith('PGRST') && /116|404|425|427/.test(code)) return true;

  return false;
}

export function shouldRetryQuery(failureCount, error) {
  if (failureCount >= MAX_QUERY_RETRIES) return false;
  if (isClientError(error)) return false;
  return true;
}

export function queryRetryDelay(attemptIndex) {
  return RETRY_BASE_MS * (attemptIndex + 1) + Math.random() * RETRY_JITTER_MS;
}
